import { DisciplinaryCategoryService, DisciplinaryGradationService, DisciplinaryService } from '@services/all.services';
import { useNotification } from "@hooks/useNotification";
import { useReduxSelector } from '@hooks/useReduxSelector';
import { checkEnterpriseId } from '@helpers/_functions';
import { MODEL_NAME_EMPLOI_DISCIPLINNARY } from '@helpers/_constants';
import { NotificationUtil } from '@utils/notification.utils';

export default function useDisciplinary() {
  const { showSuccess, showError, showInfo } = useNotification();

  const disciplinaryCategoryList = useReduxSelector(({ disciplinary }) => disciplinary.disciplinaryCategory.list);
  const disciplinaryGradationList = useReduxSelector(({ disciplinary }) => disciplinary.disciplinaryGradation.list);


  const upsertDisciplinary = (disciplinary, callbackSuccess, notifAdd = true) => {
    const formData = new FormData();
    for (const attr in disciplinary) {
      if (attr !== "files" && disciplinary[attr] !== undefined)
        formData.append(`${attr}`, disciplinary[attr]);
    }
    if (disciplinary.files?.length > 0) {
      const enterprise = JSON.parse(localStorage.getItem("Enterprise"));
      formData.append("sourceModel", MODEL_NAME_EMPLOI_DISCIPLINNARY);
      formData.append("enterpriseName", enterprise?.enterpriseName);
      formData.append("enterpriseId", enterprise?._id);
      for (const file of disciplinary.files) {
        formData.append("files", file);
      }
    }

    return DisciplinaryService
      .upsertDisciplinary(formData, { Enterprise: checkEnterpriseId() })
      .then((upsertedDisciplinary) => {
        if (upsertedDisciplinary === "ALREADY_EXISTS") {
          showInfo("already_exists", {
            object: "existEmploiDisciplinary",
            object2: disciplinary.title,
          });
          return;
        }
        if (typeof disciplinary._id === "undefined") {
          showSuccess("creation_action_success", {
            object: "emploiDisciplinary",
          });
          if (notifAdd)
            NotificationUtil.emploiDisciplinaryAdd(upsertedDisciplinary);
        } else {
          showSuccess("changes_saved");
          // NotificationUtil.emploiDisciplinaryUpdate(upsertedDisciplinary);
        }
        callbackSuccess(upsertedDisciplinary);
      })
      .catch((err) => {
        console.log("Disciplinary upsert: ", err);
        showError("error");
      });
  };

    const deleteDisciplinary = (id, callback) => {
      (async () => {
        try {
          const res = await DisciplinaryService.deleteDisciplinary(id, {
            Enterprise: checkEnterpriseId(),
          });
          if (!res) {
            throw new Error("No result");
          }
          showSuccess("delete_action_success", {
            object: "emploiDisciplinary",
          });
        } catch (err) {
          console.log("EmploiDisciplinary delete: ", err);
          showError("error");
        }
        callback();
      })();
    };
  
    const handleFormErrors = (errors) => {
      const errorArray = Object.values(errors);
      if (errorArray.some((err) => err.type === "required")) {
        showError("field_obligatory");
        return;
      }
    };

  function addDisciplinaryCategory(data) {
    const { _id, ...requestData } = data;
    DisciplinaryCategoryService.insert(requestData)
      .then((response) => {
        if (response?.data?.data === "FORBIDDEN") {
          showError("already_exists", { object: "categoryUpper" });
          return;
        }
        showSuccess("creation_action_success", { object: "categoryLower" });
      })
      .catch(() => {
        showError("error_occured", { mode: "action_mode_add", object: "categoryUpper" });
      });
  }

  function deleteDisciplinaryCategory(data) {
    return DisciplinaryCategoryService.deleteById(data._id)
      .then((response) => {
          if (response?.data?.data === "CATEGORY_IN_USE") {
          showError("Suppression impossible, catégorie utilisée pour d'autres événements");
          return;
        }
        if (response?.data?.data === "FORBIDDEN") {
          showError("already_used", { object1: "categoryUpper", object2: "disciplinary" });
          return;
        }
        showSuccess("delete_action_success", { object: "categoryUpper" });
        return true
      })
      .catch((error) => {
        console.error("Delete disciplinary category : ", error);
        showError("error_occured", { mode: "action_mode_delete", object: "categoryUpper" });
      });
  }

  function addDisciplinaryGradation(data) {
    const { _id, ...requestData } = data;
    DisciplinaryGradationService.insert(requestData)
      .then((response) => {
        if (response?.data?.data === "FORBIDDEN") {
          showError("already_exists", { object: "gradationUpper" });
          return;
        }
        showSuccess("creation_action_success", { object: "gradationLower" });
      })
      .catch(() => {
        showError("error_occured", { mode: "action_mode_add", object: "gradationUpper" });
      });
  }

  function deleteDisciplinaryGradation(data) {
   return  DisciplinaryGradationService.deleteById(data._id)
      .then((response) => {
        if (response?.data?.data === "GRADATION_IN_USE") {
          showError("Suppression impossible, gradation utilisée pour d'autres événements");
          return;
        }
        if (response?.data?.data === "FORBIDDEN") {
          showError("already_used", { object1: "gradationUpper", object2: "disciplinary" });
          return;
        }
        showSuccess("delete_action_success", { object: "gradationUpper" });
        return true
      })
      .catch((error) => {
        console.error("Delete disciplinary gradation : ", error);
        showError("error_occured", { mode: "action_mode_delete", object: "gradationUpper" });
      });
  }

  return {
    disciplinaryCategoryList,
    addDisciplinaryCategory,
    deleteDisciplinaryCategory,
    disciplinaryGradationList,
    addDisciplinaryGradation,
    deleteDisciplinaryGradation,
    upsertDisciplinary,
    deleteDisciplinary,
    handleFormErrors
  };
}
